export function UserLoveIcon({ ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.50629 9.67776C2.05492 9.04472 2.82123 8.66667 3.64428 8.66667H7.68873C8.51178 8.66667 9.27808 9.04472 9.82672 9.67776C10.3728 10.3078 10.6665 11.1443 10.6665 12V13.3333C10.6665 13.7015 10.368 14 9.99984 14C9.63165 14 9.33317 13.7015 9.33317 13.3333V12C9.33317 11.4412 9.13994 10.9212 8.81914 10.551C8.50094 10.1839 8.09156 10 7.68873 10H3.64428C3.24145 10 2.83207 10.1839 2.51387 10.551C2.19307 10.9212 1.99984 11.4412 1.99984 12V13.3333C1.99984 13.7015 1.70136 14 1.33317 14C0.964981 14 0.666504 13.7015 0.666504 13.3333V12C0.666504 11.1443 0.960253 10.3078 1.50629 9.67776Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6665 3.33333C4.74603 3.33333 3.99984 4.07953 3.99984 5C3.99984 5.92047 4.74603 6.66667 5.6665 6.66667C6.58698 6.66667 7.33317 5.92047 7.33317 5C7.33317 4.07953 6.58698 3.33333 5.6665 3.33333ZM2.6665 5C2.6665 3.34315 4.00965 2 5.6665 2C7.32336 2 8.6665 3.34315 8.6665 5C8.6665 6.65685 7.32336 8 5.6665 8C4.00965 8 2.6665 6.65685 2.6665 5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3666 6.67559C13.2685 6.69728 13.0894 6.78096 12.9185 7.11831C12.8049 7.34238 12.575 7.48359 12.3238 7.48358C12.0726 7.48357 11.8427 7.34235 11.7291 7.11827C11.5574 6.7793 11.3821 6.70221 11.2931 6.68329C11.1879 6.66095 11.049 6.6872 10.9122 6.79103C10.7738 6.89605 10.689 7.04343 10.6705 7.17686C10.6554 7.28647 10.676 7.43765 10.8564 7.61565L12.3238 9.06348L13.7913 7.61571C13.9897 7.41988 14.0103 7.25898 13.9963 7.15235C13.9794 7.02277 13.8973 6.88033 13.7597 6.77855C13.6237 6.67796 13.4803 6.65046 13.3666 6.67559ZM15.3184 6.9796C15.3909 7.53381 15.198 8.10075 14.7278 8.56474L12.792 10.4746C12.5324 10.7307 12.1152 10.7307 11.8556 10.4746L9.91995 8.56477C9.45515 8.10617 9.27415 7.54118 9.34974 6.9943C9.42204 6.47124 9.72027 6.0218 10.1061 5.72895C10.4936 5.43489 11.02 5.26218 11.5702 5.37907C11.8467 5.43782 12.1002 5.56333 12.3236 5.7481C12.548 5.56184 12.8023 5.43481 13.0788 5.37369C13.6277 5.25233 14.1585 5.41507 14.5526 5.70656C14.9451 5.99685 15.249 6.44832 15.3184 6.9796Z"
        fill="currentColor"
      />
    </svg>
  );
}
